import React from 'react';

function Projects() {
  const projects = [
    {
      name: "RQ4-B Dynamic Mission Operations (DYNAMO)",
      description: "Northrop Grumman was awarded a contract by the United States Air Force to provide dynamic inflight rerouting for RQ-4B Global Hawk.",
      image: "/images/Global-Hawk.jpg",
      imageAlt: "RQ-4B Global Hawk aircraft in flight",
      imageWidth: 2000,
      imageHeight: 1000,
      modernImageBase: "/images/projects/global-hawk",
      modernImageWidth: 960,
      link: "https://news.northropgrumman.com/news/releases/northrop-grumman-awarded-mission-planning-contract-to-increase-global-hawk-operational-flexibility"
    },
    {
      name: "The Craft Creamery",
      description: "An ice cream tasting bar located in San Diego.",
      image: "/images/craft-creamery.jpg",
      imageAlt: "Exterior of The Craft Creamery in San Diego",
      imageWidth: 2249,
      imageHeight: 1499,
      modernImageBase: "/images/projects/craft-creamery",
      modernImageWidth: 960,
      link: "https://www.craftcreamerysd.com/about"
    },
    {
      name: "DizzyDoctor",
      description: "A FDA cleared mobile app that allows users to diagnose and treat dizziness and vertigo.",
      image: "/images/dizzydoctor.png",
      imageAlt: "DizzyDoctor mobile app interface",
      imageWidth: 1335,
      imageHeight: 688,
      modernImageBase: "/images/projects/dizzydoctor",
      modernImageWidth: 960,
      link: "https://www.accessdata.fda.gov/cdrh_docs/pdf18/K182214.pdf"
    },
    {
      name: "JB10 Jetpack",
      description: "Led the development of a personal jetpack system capable of vertical takeoff and landing (VTOL) with advanced stabilization.",
      image: "/images/jetpack.jpg",
      imageAlt: "JB10 personal jetpack in flight",
      imageWidth: 1000,
      imageHeight: 562,
      modernImageBase: "/images/projects/jb10-jetpack",
      modernImageWidth: 960,
      link: "https://www.youtube.com/watch?v=nj-Iwv5NJKg"
    },
    {
      name: "JB11 Jetpack",
      description: "Developed an advanced self stabilizing 6 turbojet personal jetpack system with thrust vectoring and enhanced flight controls.",
      image: "/images/jb11.jpg",
      imageAlt: "JB11 six-engine personal jetpack",
      imageWidth: 1920,
      imageHeight: 1080,
      modernImageBase: "/images/projects/jb11-jetpack",
      modernImageWidth: 960,
      link: "https://www.youtube.com/watch?v=tqS_wTu1lH4&t=239s"
    },
    {
      name: "SPEEDER",
      description: "Created a dynamically unstable propulsion system optimized for high-speed, low-altitude flight operations.",
      image: "/images/JPA-Recreational-Speeder-2021.jpg",
      imageAlt: "JetPack Aviation SPEEDER concept vehicle",
      imageWidth: 800,
      imageHeight: 452,
      modernImageBase: "/images/projects/speeder",
      modernImageWidth: 800,
      link: "https://www.youtube.com/watch?v=URgznwTph6M"
    }
  ];

  return (
    <>
      <h2 className="section-header">Projects</h2>
      <div className="content-section projects-section">
        {projects.map((project) => (
          <div key={project.name} className="content-item project-entry">
            {project.image && (
              <picture className="project-media">
                <source
                  type="image/avif"
                  srcSet={`${project.modernImageBase}-480.avif 480w, ${project.modernImageBase}-${project.modernImageWidth}.avif ${project.modernImageWidth}w`}
                  sizes="(max-width: 768px) calc(100vw - 6rem), (max-width: 1200px) 50vw, 33vw"
                />
                <img
                  src={project.image}
                  alt={project.imageAlt}
                  className="project-image"
                  width={project.imageWidth}
                  height={project.imageHeight}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            )}
            <h3 className="projects-title">{project.name}</h3>
            <p className="project-description">{project.description}</p>
            {project.link && (
              <a 
                href={project.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="article-link"
                aria-label={`Read more about ${project.name} (opens in a new tab)`}
              >
                Read more
              </a>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

export default Projects;
